<template>
  <v-speed-dial-horus v-model="active" direction="bottom" transition="scale-transition">
    <template v-slot:activator>
      <div class="aero-top-toolbar">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn @click="toggleFeatures" variant="text" elevation="0" class="aero-tool-btn aero-right-space" fab small
              v-on="on">
              <svg v-if="isFeaturesActive" width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_201_1299)">
                  <path
                    d="M10.5851 10.587C10.21 10.9622 9.99942 11.4709 9.99951 12.0014C9.99961 12.5318 10.2104 13.0405 10.5856 13.4155C10.9607 13.7905 11.4695 14.0012 11.9999 14.0011C12.5304 14.001 13.039 13.7902 13.4141 13.415"
                    stroke="#212222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M16.681 16.673C15.2782 17.5507 13.6547 18.0109 12 18C8.4 18 5.4 16 3 12C4.272 9.88 5.712 8.322 7.32 7.326M10.18 6.18C10.779 6.05873 11.3888 5.99842 12 6C15.6 6 18.6 8 21 12C20.334 13.11 19.621 14.067 18.862 14.87"
                    stroke="#212222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M3 3L21 21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_201_1299">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <svg v-else class="text--secondary" width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_201_1272)">
                  <path
                    d="M10 12C10 12.5304 10.2107 13.0391 10.5858 13.4142C10.9609 13.7893 11.4696 14 12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12Z"
                    stroke="#212222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M21 12C18.6 16 15.6 18 12 18C8.4 18 5.4 16 3 12C5.4 8 8.4 6 12 6C15.6 6 18.6 8 21 12Z"
                    stroke="#212222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_201_1272">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </v-btn>
          </template>
          <span>Show/Hide</span>
        </v-tooltip>
        <processing-downloads-shared :id-processing="processing['id_processing']" :processing="processing">
          <template v-slot:activator="{ on: dialog }">
            <v-tooltip right>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn id="processing-downloads" variant="text" elevation="0" class="aero-tool-btn aero-right-space" fab
                  small v-on="{ ...dialog, ...tooltip }">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_201_1289)">
                      <path
                        d="M4 17V19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21H18C18.5304 21 19.0391 20.7893 19.4142 20.4142C19.7893 20.0391 20 19.5304 20 19V17"
                        stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M7 11L12 16L17 11" stroke="black" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M12 4V16" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                    <defs>
                      <clipPath id="clip0_201_1289">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                </v-btn>
              </template>
              <span>Downloads</span>
            </v-tooltip>
          </template>
        </processing-downloads-shared>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn id="toolbox-toggle-help" href="https://mappa.ag/ajuda/" target="_blank" variant="text" elevation="0"
              class="aero-tool-btn" fab small v-on="on">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_201_1294)">
                  <path
                    d="M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C10.8181 3 9.64778 3.23279 8.55585 3.68508C7.46392 4.13738 6.47177 4.80031 5.63604 5.63604C4.80031 6.47177 4.13738 7.46392 3.68508 8.55585C3.23279 9.64778 3 10.8181 3 12Z"
                    stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M12 17V17.01" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M12 13.5C11.9816 13.1754 12.0692 12.8536 12.2495 12.583C12.4299 12.3125 12.6933 12.1079 13 12C13.3759 11.8563 13.7132 11.6272 13.9856 11.331C14.2579 11.0347 14.4577 10.6792 14.5693 10.2926C14.6809 9.90597 14.7013 9.49871 14.6287 9.10288C14.5562 8.70705 14.3928 8.33346 14.1513 8.01153C13.9099 7.68959 13.597 7.4281 13.2373 7.24763C12.8776 7.06716 12.4809 6.97265 12.0785 6.97154C11.6761 6.97042 11.2789 7.06273 10.9182 7.2412C10.5576 7.41967 10.2432 7.67942 10 8.00001"
                    stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_201_1294">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>

            </v-btn>
          </template>
          <span>Help</span>
        </v-tooltip>
      </div>
      <div class="aero-side-toolbar">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn style="margin-bottom: 25px;" id="toolbox-polygon-draw" @click="togglePolygonDraw" variant="text"
              elevation="0" class="aero-tool-btn" fab small v-on="on">

              <svg v-if="isDrawingPolygon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_201_1247)">
                  <path
                    d="M10 5C10 5.53043 10.2107 6.03914 10.5858 6.41421C10.9609 6.78929 11.4696 7 12 7C12.5304 7 13.0391 6.78929 13.4142 6.41421C13.7893 6.03914 14 5.53043 14 5C14 4.46957 13.7893 3.96086 13.4142 3.58579C13.0391 3.21071 12.5304 3 12 3C11.4696 3 10.9609 3.21071 10.5858 3.58579C10.2107 3.96086 10 4.46957 10 5Z"
                    stroke="#00B3FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M17 8C17 8.53043 17.2107 9.03914 17.5858 9.41421C17.9609 9.78929 18.4696 10 19 10C19.5304 10 20.0391 9.78929 20.4142 9.41421C20.7893 9.03914 21 8.53043 21 8C21 7.46957 20.7893 6.96086 20.4142 6.58579C20.0391 6.21071 19.5304 6 19 6C18.4696 6 17.9609 6.21071 17.5858 6.58579C17.2107 6.96086 17 7.46957 17 8Z"
                    stroke="#00B3FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M3 11C3 11.5304 3.21071 12.0391 3.58579 12.4142C3.96086 12.7893 4.46957 13 5 13C5.53043 13 6.03914 12.7893 6.41421 12.4142C6.78929 12.0391 7 11.5304 7 11C7 10.4696 6.78929 9.96086 6.41421 9.58579C6.03914 9.21071 5.53043 9 5 9C4.46957 9 3.96086 9.21071 3.58579 9.58579C3.21071 9.96086 3 10.4696 3 11Z"
                    stroke="#00B3FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M13 19C13 19.5304 13.2107 20.0391 13.5858 20.4142C13.9609 20.7893 14.4696 21 15 21C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19C17 18.4696 16.7893 17.9609 16.4142 17.5858C16.0391 17.2107 15.5304 17 15 17C14.4696 17 13.9609 17.2107 13.5858 17.5858C13.2107 17.9609 13 18.4696 13 19Z"
                    stroke="#00B3FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M6.5 9.5L10 6.5" stroke="#00B3FF" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M14 5.5L17 7" stroke="#00B3FF" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M18.5 10L16 17" stroke="#00B3FF" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M13.5 17.5L6.5 12.5" stroke="#00B3FF" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_201_1247">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_201_1257)">
                  <path
                    d="M10 5C10 5.53043 10.2107 6.03914 10.5858 6.41421C10.9609 6.78929 11.4696 7 12 7C12.5304 7 13.0391 6.78929 13.4142 6.41421C13.7893 6.03914 14 5.53043 14 5C14 4.46957 13.7893 3.96086 13.4142 3.58579C13.0391 3.21071 12.5304 3 12 3C11.4696 3 10.9609 3.21071 10.5858 3.58579C10.2107 3.96086 10 4.46957 10 5Z"
                    stroke="#212222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M17 8C17 8.53043 17.2107 9.03914 17.5858 9.41421C17.9609 9.78929 18.4696 10 19 10C19.5304 10 20.0391 9.78929 20.4142 9.41421C20.7893 9.03914 21 8.53043 21 8C21 7.46957 20.7893 6.96086 20.4142 6.58579C20.0391 6.21071 19.5304 6 19 6C18.4696 6 17.9609 6.21071 17.5858 6.58579C17.2107 6.96086 17 7.46957 17 8Z"
                    stroke="#212222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M3 11C3 11.5304 3.21071 12.0391 3.58579 12.4142C3.96086 12.7893 4.46957 13 5 13C5.53043 13 6.03914 12.7893 6.41421 12.4142C6.78929 12.0391 7 11.5304 7 11C7 10.4696 6.78929 9.96086 6.41421 9.58579C6.03914 9.21071 5.53043 9 5 9C4.46957 9 3.96086 9.21071 3.58579 9.58579C3.21071 9.96086 3 10.4696 3 11Z"
                    stroke="#212222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M13 19C13 19.5304 13.2107 20.0391 13.5858 20.4142C13.9609 20.7893 14.4696 21 15 21C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19C17 18.4696 16.7893 17.9609 16.4142 17.5858C16.0391 17.2107 15.5304 17 15 17C14.4696 17 13.9609 17.2107 13.5858 17.5858C13.2107 17.9609 13 18.4696 13 19Z"
                    stroke="#212222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M6.5 9.5L10 6.5" stroke="#212222" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M14 5.5L17 7" stroke="#212222" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M18.5 10L16 17" stroke="#212222" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M13.5 17.5L6.5 12.5" stroke="#212222" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_201_1257">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>


            </v-btn>
          </template>
          <span>Draw area</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn style="margin-bottom: 25px;" id="toolbox-polyline-draw" @click="togglePolylineDraw" variant="text"
              elevation="0" class="aero-tool-btn" fab small v-on="on">
              <svg v-if="isDrawingPolyline" width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_201_1267)">
                  <path
                    d="M4 18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20C6.53043 20 7.03914 19.7893 7.41421 19.4142C7.78929 19.0391 8 18.5304 8 18C8 17.4696 7.78929 16.9609 7.41421 16.5858C7.03914 16.2107 6.53043 16 6 16C5.46957 16 4.96086 16.2107 4.58579 16.5858C4.21071 16.9609 4 17.4696 4 18Z"
                    stroke="#00B3FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M16 6C16 6.53043 16.2107 7.03914 16.5858 7.41421C16.9609 7.78929 17.4696 8 18 8C18.5304 8 19.0391 7.78929 19.4142 7.41421C19.7893 7.03914 20 6.53043 20 6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4C17.4696 4 16.9609 4.21071 16.5858 4.58579C16.2107 4.96086 16 5.46957 16 6Z"
                    stroke="#00B3FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M7.5 16.5L16.5 7.5" stroke="#00B3FF" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_201_1267">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_201_1276)">
                  <path
                    d="M4 18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20C6.53043 20 7.03914 19.7893 7.41421 19.4142C7.78929 19.0391 8 18.5304 8 18C8 17.4696 7.78929 16.9609 7.41421 16.5858C7.03914 16.2107 6.53043 16 6 16C5.46957 16 4.96086 16.2107 4.58579 16.5858C4.21071 16.9609 4 17.4696 4 18Z"
                    stroke="#212222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M16 6C16 6.53043 16.2107 7.03914 16.5858 7.41421C16.9609 7.78929 17.4696 8 18 8C18.5304 8 19.0391 7.78929 19.4142 7.41421C19.7893 7.03914 20 6.53043 20 6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4C17.4696 4 16.9609 4.21071 16.5858 4.58579C16.2107 4.96086 16 5.46957 16 6Z"
                    stroke="#212222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M7.5 16.5L16.5 7.5" stroke="#212222" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_201_1276">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>

            </v-btn>
          </template>
          <span>Mesure distance</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn id="toolbox-marker-draw" @click="toggleMarkerDraw" variant="text" elevation="0" class="aero-tool-btn"
              fab small v-on="on">
              <svg v-if="isDrawingMarker" width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_201_1281)">
                  <path
                    d="M9 11C9 11.7956 9.31607 12.5587 9.87868 13.1213C10.4413 13.6839 11.2044 14 12 14C12.7956 14 13.5587 13.6839 14.1213 13.1213C14.6839 12.5587 15 11.7956 15 11C15 10.2044 14.6839 9.44129 14.1213 8.87868C13.5587 8.31607 12.7956 8 12 8C11.2044 8 10.4413 8.31607 9.87868 8.87868C9.31607 9.44129 9 10.2044 9 11Z"
                    stroke="#00B3FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M17.657 16.657L13.414 20.9C13.039 21.2746 12.5306 21.4851 12.0005 21.4851C11.4704 21.4851 10.962 21.2746 10.587 20.9L6.343 16.657C5.22422 15.5382 4.46234 14.1127 4.15369 12.5609C3.84504 11.009 4.00349 9.40053 4.60901 7.93874C5.21452 6.47696 6.2399 5.22755 7.55548 4.34852C8.87107 3.46949 10.4178 3.00031 12 3.00031C13.5822 3.00031 15.1289 3.46949 16.4445 4.34852C17.7601 5.22755 18.7855 6.47696 19.391 7.93874C19.9965 9.40053 20.155 11.009 19.8463 12.5609C19.5377 14.1127 18.7758 15.5382 17.657 16.657Z"
                    stroke="#00B3FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_201_1281">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_201_1285)">
                  <path
                    d="M9 11C9 11.7956 9.31607 12.5587 9.87868 13.1213C10.4413 13.6839 11.2044 14 12 14C12.7956 14 13.5587 13.6839 14.1213 13.1213C14.6839 12.5587 15 11.7956 15 11C15 10.2044 14.6839 9.44129 14.1213 8.87868C13.5587 8.31607 12.7956 8 12 8C11.2044 8 10.4413 8.31607 9.87868 8.87868C9.31607 9.44129 9 10.2044 9 11Z"
                    stroke="#212222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M17.657 16.657L13.414 20.9C13.039 21.2746 12.5306 21.4851 12.0005 21.4851C11.4704 21.4851 10.962 21.2746 10.587 20.9L6.343 16.657C5.22422 15.5382 4.46234 14.1127 4.15369 12.5609C3.84504 11.009 4.00349 9.40053 4.60901 7.93874C5.21452 6.47696 6.2399 5.22755 7.55548 4.34852C8.87107 3.46949 10.4178 3.00031 12 3.00031C13.5822 3.00031 15.1289 3.46949 16.4445 4.34852C17.7601 5.22755 18.7855 6.47696 19.391 7.93874C19.9965 9.40053 20.155 11.009 19.8463 12.5609C19.5377 14.1127 18.7758 15.5382 17.657 16.657Z"
                    stroke="#212222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_201_1285">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </v-btn>
          </template>
          <span>Get coordinates</span>
        </v-tooltip>
      </div>
      <!-- <v-btn
        @click="active = !active"
        color="primary"
        fab
      >
        <v-icon v-if="active">mdi-close</v-icon>
        <v-icon v-else>mdi-tools</v-icon>
      </v-btn> -->
    </template>


  </v-speed-dial-horus>
</template>

<script>
import VSpeedDialHorus from "../../Helpers/Vuetify/VSpeedDial"
import { FEATURE_GROUPS } from "../../../helpers/leaflet/constants"
import ProcessingDownloadsShared from "../../../components/Processings/ProcessingDownloadsShared"

const _Map = Symbol.for("_Map")

export default {
  name: "ToolBox",
  inject: { _Map },
  components: { VSpeedDialHorus, ProcessingDownloadsShared },
  props: {
    processing: {
      required: true,
    },
  },
  data: () => ({
    active: true,
    isFeaturesActive: true,

    isDrawingPolygon: false,
    isDrawingPolyline: false,
    isDrawingMarker: false,

    feature: null,
  }),

  methods: {
    toggleFeatures() {
      this.isFeaturesActive = !this.isFeaturesActive
      if (this.isFeaturesActive)
        this.Map.featureGroups[FEATURE_GROUPS.FEATURES].addTo(this.Map)
      else
        this.Map.featureGroups[FEATURE_GROUPS.FEATURES].remove()
    },
    togglePolygonDraw() {
      this.turnEventsOn()
      if (this.isDrawingPolygon)
        this.clearDraw()
      else {
        this.clearDraw()
        this.isDrawingPolygon = true
        this.feature = new window.L.Draw.Polygon(this.Map, {
          allowIntersection: false
        })
        this.feature.enable()
      }
    },
    togglePolylineDraw() {
      this.turnEventsOn()
      if (this.isDrawingPolyline)
        this.clearDraw()
      else {
        this.clearDraw()
        this.isDrawingPolyline = true
        var opt = {
          metric: true,
          precision: { m: 2 },
        }
        this.feature = new window.L.Draw.Polyline(this.Map, opt)
        this.feature.enable()
      }
    },
    toggleMarkerDraw() {
      this.turnEventsOn()
      if (this.isDrawingMarker)
        this.clearDraw()
      else {
        this.clearDraw()
        this.isDrawingMarker = true
        this.feature = new window.L.Draw.Marker(this.Map)
        this.feature.enable()
      }
    },
    clearDraw() {
      this.isDrawingPolygon = false
      this.isDrawingPolyline = false
      this.isDrawingMarker = false

      if (this.feature) {
        this.feature.disable()
        this.feature = null
      }
    },
    escIsDown(event) {
      if (event.originalEvent.key === "Escape") {
        this.clearDraw()
        this.turnEventsOff()
      }
    },
    onDrawCreated() {
      this.clearDraw()
      this.turnEventsOff()
    },
    turnEventsOn() {
      this.Map.on(window.L.Draw.Event.CREATED, this.onDrawCreated)
      this.Map.on("keydown", this.escIsDown)
    },
    turnEventsOff() {
      this.Map.off(window.L.Draw.Event.CREATED, this.onDrawCreated)
      this.Map.off("keydown", this.escIsDown)
    },
  },
  computed: {
    Map: {
      get() {
        return this._Map()
      },
    },
    visibilityButtonColor() {
      return this.isFeaturesActive ? "accent" : ""
    },
    polygonButtonColor() {
      return this.isDrawingPolygon ? "accent" : ""
    },
    polylineButtonColor() {
      return this.isDrawingPolyline ? "accent" : ""
    },
    markerButtonColor() {
      return this.isDrawingMarker ? "accent" : ""
    },
    isAnyDrawActive() {
      return this.isDrawingPolygon || this.isDrawingPolyline || this.isDrawingMarker
    },
  },
}
</script>

<style scoped></style>
